import styled from "styled-components";

const TextSpan = styled.span`
  font-weight: bold;
  color: ${props => (props.color ? props.color : "blue")};
`;

export default TextSpan;
